import { AnalyticsEvent } from '../../analytics.event';

export class ErrorOccurredEvent extends AnalyticsEvent {
    constructor(errorType: string, errorMessage: string) {
        super('error_occurred', {
            error_type: errorType,
            error_message: errorMessage
        });
    }
}
